import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-rt-usecases',
	templateUrl:'./UseCasesPage.html',
	styles: [],
	styleUrls:['./UseCasesPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		WaCardDirective,
		RouterModule,
		WaButtonDirective,
],
	standalone:true
})
export class UseCasesPage
{
}
